import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/balanceo/ico1.png")